/**
 * @file NoCreditsModal.tsx
 *
 * Renders the no credits modal. This displays a message to the user that they
 * have to buy credits to create a contact request.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PaymentIcon } from '~/vcl/icons/Payment';
import { LinkButton } from '~/vcl/atoms/01-forms/01-button/02-link-button';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { EmptyElement } from '~/vcl/molecules/02-empty';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

export const NoCreditsModal = () => {
  const { RESUME } = useFrontendConfig();

  return (
    <EmptyElement icon={<PaymentIcon title="PAY" />}>
      <FormattedMessage
        id="contact_request_no_credits_modal"
        defaultMessage="You don't have credits to create a contact request, you can buy contact credits by going to the pricing page."
      />
      <Spacing />
      <LinkButton
        href={RESUME.RESUME_CONTACT_CREDITS_PAGE}
        buttonStyle="primary"
      >
        <PaymentIcon title="PAY" />
        <span>
          <FormattedMessage
            id="contact_request_no_credits_modal_action"
            defaultMessage="Buy credits"
          />
        </span>
      </LinkButton>
    </EmptyElement>
  );
};

export default NoCreditsModal;
